/** 旅游分包业务文案 — 中文 */
export default {
  tourism: {
    nav: {
      home: '旅游首页',
      list: '旅游列表',
      detail: '线路详情',
      order: '提交订单',
      selectCity: '选择城市',
    },

    common: {
      tourism: '旅游',
      search: '搜索',
      wantToGo: '我想去',
      hotRecommend: '热门推荐',
      priceFrom: '起',
      all: '全部',
      line: '线路',
      ticket: '门票',
      keyword: '关键词',
      noShopping: '无购物',
      supportRefundChange: '支持退改',
      refundAnytime: '过期未使用随时退',
      play: '游玩',
      scenicSpot: '景点',
      bookNow: '立即预订',
      addCart: '加入购物车',
      addingCart: '添加中',
      notForSale: '暂不可售',
      confirm: '确定',
      cancel: '取消',
      edit: '编辑',
      add: '新增',
      done: '完成',
      delete: '删除',
      none: '无',
      navigate: '导航',
      selected: '已选',
      yuan: '元',
      male: '男',
      female: '女',
      tip: '提示',
      thinkAgain: '再想想',
      required: '必选',
    },

    share: {
      homeTitle: '0息暴走·分期解锁·秘境任闯',
      homeDesc: '全场分期  0利息0手续费  40家银行信任支持的平台',
      productTitle: "{'@'}您查收｜{name}惠民游",
    },

    ticketStatus: {
      available: '有票',
      unavailable: '无票',
    },

    date: {
      today: '今天',
      tomorrow: '明天',
      dayAfter: '后天',
      weekdaySun: '周日',
      weekdayMon: '周一',
      weekdayTue: '周二',
      weekdayWed: '周三',
      weekdayThu: '周四',
      weekdayFri: '周五',
      weekdaySat: '周六',
      monthDay: '{month}月{day}日',
      moreDates: '更多日期',
    },

    list: {
      tabAll: '全部',
      tabLine: '线路',
      tabTicket: '门票',
      sortPrice: '价格',
      sortSales: '销量',
      sortRecommend: '推荐值',
      sortListed: '上架时间',
      playPrefix: '游玩',
      playSuffix: '景点',
    },

    detail: {
      relatedProducts: '相关产品',
      packageSelect: '套餐选择',
      itinerary: '行程',
      package: '套餐',
      basicInfo: '基本信息',
      productNo: '产品编号：',
      bookingNote: '预订说明：',
      remarkNote: '备注说明：',
      departure: '出发地：',
      days: '天数',
      refundNote: '退款说明',
      refundNotSupported: '不支持退款',
      refundSupported: '支持退款',
      refundRuleNotice: '退款说明以当前说明为准',
      bookingNotice: '预订须知',
      meetingPoint: '集合地',
      packageService: '套餐服务',
      itineraryDetail: '详细行程',
      itineraryLabel: '行程·{desc}',
      trafficLabel: '交通·{desc}',
      mealsLabel: '餐食·{breakfast} 午餐·{lunch} 晚餐·{dinner}',
      hotelLabel: '酒店·{desc}',
      scenicLabel: '景点·{desc}',
      selfPaidScenicLabel: '自费景点·{desc}',
      graphicDetail: '图文详情',
      costIncluded: '费用包含',
      costExcluded: '费用自理',
      beforePurchase: '购买前须知',
      agreePrefix: '我已阅读并同意',
      agreeLink: '购买前须知',
      agreeRequired: '请先同意购买须知',
      noRefundTitle: '提示',
      noRefundMsg: '当前商品购买后不可退款',
      noRefundConfirm: '确定不退款并下单',
      noRefundCartConfirm: '确定不退款并继续',
      continueAddCart: '继续加入购物车',
      cartPopupTitle: '选择并加入购物车',
      addCartSuccess: '已加入购物车',
      addCartFailed: '加入购物车失败，请稍后重试',
      loginFailed: '登录页面打开失败，请稍后重试',
      cartProductInvalid: '商品或报价已更新，请重新选择',
      productOffShelf: '产品已下架',
    },

    selectCity: {
      searchPlaceholder: '请输入城市名称搜索',
      history: '历史搜索',
      hotDomestic: '国内热门城市',
      noResult: '当前无结果',
      cityLabel: '城市',
      searchNoResult: '当前搜索无结果',
    },

    components: {
      selectDate: {
        title: '选择出发日期',
      },
    },

    order: {
      selectedPackage: '已选套餐：',
      validTime: '有效时间：',
      multiTicketTip: '此为{count}人票，需选择{count}位游客',
      sessionSelect: '场次选择',
      valueAdded: '增值项目',
      deliveryMethod: '配送方式',
      physicalTicketDelivery: '(实体票配送方式)',
      expressDelivery: '快递配送，需另加',
      touristInfo: '游客信息',
      touristNeedAdd: '需添加',
      touristForVerify: '位游客，用于身份验证',
      touristIndex: '游客{index}',
      addTouristInfo: '新增游客信息',
      touristNeedAddInfo: '需添加',
      touristInfoSuffix: '位游客信息',
      pickupPoint: '上车点',
      returnPoint: '回程点',
      selectPickupFirst: '请先选择上车点',
      selectReturnFirst: '请先选择回程点',
      contact: '联系人',
      contactHint: '用于出游信息事项确认',
      chineseName: '中文姓名',
      namePlaceholder: '必填，请输入证件上的名字',
      mobile: '手机号',
      mobilePlaceholder: '必填，请输入联系人手机号',
      shippingAddress: '收货地址',
      detailAddress: '详细地址',
      addressPlaceholder: '街道，楼牌号等',
      moreDiscount: '更多优惠',
      coupon: '优惠券',
      couponAvailable: '{count}张可用',
      couponNone: '暂无可用',
      bankOnlyPay: '仅限{bank}支付可用',
      designatedBank: '指定银行',
      editTraveler: '编辑出行人',
      addTraveler: '新增出行人',
      name: '姓名',
      nameMatchId: '与证件一致',
      idNumber: '证件号',
      gender: '性别',
      contactPhone: '联系电话',
      contactPhonePlaceholder: '请填写联系电话',
      selectedCount: '已选择{count}人',
      addTravelerBtn: '新增出行人',
      selectCoupon: '选择优惠券',
      loadingCoupons: '获取优惠券中...',
      noCoupons: '暂无可用优惠券',
      skipCoupon: '不使用优惠券',
      couponValidUntil: '有效期至：{time}',
      couponUnusable: '当前不可用',
      discountFold: '折',
      quantitySelect: '数量选择',
      validSameDay: '购买后{date}当日有效',
      validUntil: '购买后截止到{date}有效',
      validUntilRaw: '购买后截止到{date}有效',
      validDateRange: '购买后指定日期{from}到{to}内有效',
      childrenRequired: '【{name}】至少需要选择 {count} 位儿童出行人',
      couponFullReduce: '满{min}减{amount}',
      couponInstantReduce: '立减{amount}元',
      couponFullDiscount: '满{min}享{discount}折',
      couponInstantDiscount: '{discount}折优惠',
      fillContactName: '请填写联系人姓名',
      fillContactPhone: '请填写联系人电话',
      selectPickup: '请选择上车点',
      selectReturn: '请选择回程点',
      selectShippingAddress: '请选择收货地址',
      fillDetailAddress: '请填写详细地址',
      selectEnoughTravelers: '请选择足够的出行人',
      selectRequiredAddons: '请选择必选的增值项目',
      addonMustMatchTotal: '项目{names}数量必须跟套餐总数相等',
      addonMinPurchase: '项目{names}最低购买数量为{mins}',
      selectPayMethod: '请选择支付方式',
      payMethodLoading: '支付方式加载中，请稍候',
      installmentPeriod: '{count}期',
      totalDiscount: '共减￥{amount}',
      deleteTravelerConfirm: '是否删除该出行人信息',
      deleteSuccess: '删除成功',
      fillComplete: '请填写完整',
      invalidIdNumber: '请输入正确的证件号',
      invalidMobile: '请填写正确的手机号',
      idVerifyFailed: '身份证验证失败',
      updateSuccess: '修改成功!',
      addSuccess: '新增成功!',
      maxSelect: '最多可选{count}人',
      outOfStock: '亲，最多购买{count}份哦～',
      fetchCouponFailed: '获取优惠券失败',
      couponSelected: '已选择优惠券，优惠￥{amount}',
      selectCouponFailed: '选择优惠券失败',
      calcDiscountFailed: '计算优惠金额失败',
      couponCancelled: '已取消优惠券',
      noThreshold: '无门槛',
      couponDefault: '优惠券',
      placePriceSuffix: '元',
      valueAddedHelp: `1.*号表示此增值项目必选
2.橙色字体表示必须跟订单数量一致`,
      idCard: '身份证',
      studentCard: '学生证',
      militaryCard: '军官证',
      passport: '护照',
      householdRegister: '户口本(儿童请选择此项)',
      hkMacaoPass: '港澳通行证',
      taiwanMainlandPass: '台湾居民来往大陆通行证',
      taiwanPass: '台湾通行证',
      taiwanEntryPermit: '入台证',
      hkResidentPass: '香港居民往来内地通行证',
      policeCard: '警官证',
      driverLicense: '驾驶证',
      seamanCard: '海员证',
      foreignerPermanentResidence: '外国人在中国永久居留证',
      macaoResidentPass: '澳门居民往来内地通行证',
      hkMacaoMainlandPass: '港澳居民来往内地通行证',
      hkMacaoTaiwanMainlandPass: '港澳台居民来往内地通行证',
      hkMacaoTaiwanResidence: '港澳台居民居住证',
      travelDocument: '中华人民共和国旅行证',
      homeReturnPermit: '回乡证',
      taiwanCompatriotCard: '台胞证',
      hkIdCard: '香港身份证',
    },
  },
}
